<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M6.75 10.313c-1.755 0-5.25.877-5.25 2.624v1.313H12v-1.313c0-1.747-3.495-2.624-5.25-2.624ZM3.255 12.75c.63-.435 2.152-.938 3.495-.938 1.342 0 2.865.503 3.495.938h-6.99ZM6.75 9a2.628 2.628 0 0 0 2.625-2.625A2.628 2.628 0 0 0 6.75 3.75a2.628 2.628 0 0 0-2.625 2.625A2.628 2.628 0 0 0 6.75 9Zm0-3.75a1.124 1.124 0 1 1 0 2.25 1.123 1.123 0 0 1-1.125-1.125c0-.622.503-1.125 1.125-1.125Zm5.28 5.107c.87.63 1.47 1.47 1.47 2.58v1.313h3v-1.313c0-1.514-2.625-2.377-4.47-2.58ZM11.25 9a2.628 2.628 0 0 0 2.625-2.625A2.628 2.628 0 0 0 11.25 3.75c-.405 0-.78.098-1.125.263a4.08 4.08 0 0 1 .75 2.362 4.08 4.08 0 0 1-.75 2.363c.345.165.72.262 1.125.262Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
